import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminEmployerProjects } from 'scenes/Renolog/services/getAdminEmployerProjects.service';

/**
 * Loads every employer project as `[{ id, name, business_id }]`, the source
 * of the company picker when adding a licence. Several projects share a
 * business id; the picker dedupes them.
 */
export const loadAdminEmployerProjects = createAsyncThunk(
  'adminAi/loadAdminEmployerProjects',
  async (_, { rejectWithValue }) => {
    try {
      return await getAdminEmployerProjects();
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to load employer projects'
      );
    }
  }
);
